import React from 'react';
const ConditionalLock = (props) => {
    return (React.createElement(React.Fragment, null,
        (!props.lockCTAs || props.conditionMet) && props.ifUnlock,
        props.lockCTAs && !props.conditionMet && props.ifLock));
};
export default ConditionalLock;
